/**
 * @generated SignedSource<<3adb1b2e457531f7216f2c32b4b613e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesSidePanel_stream$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Bookmarks_stream" | "SeriesSidePanel_allowedTabs_stream">;
  readonly " $fragmentType": "SeriesSidePanel_stream";
};
export type SeriesSidePanel_stream$key = {
  readonly " $data"?: SeriesSidePanel_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesSidePanel_stream">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesSidePanel_stream",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SeriesSidePanel_allowedTabs_stream"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Bookmarks_stream"
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};

(node as any).hash = "50869a357cdca0c7fa5b9b86ce14d506";

export default node;
